import { DaoModel } from '@dynameat/models';

export class TableQr extends DaoModel {
  constructor(guid, pointOfSale, menu, saleZone, linkTree, useLinkTree, number, email, qrCode) {
    super(guid);
    this.pointOfSale = pointOfSale;
    this.menu = menu;
    this.saleZone = saleZone;
    this.linkTree = linkTree;
    this.useLinkTree = useLinkTree;
    this.number = number;
    this.qrCode = qrCode;
    this.email = email;
  }

  static toInstance(props = {}) {
    return new TableQr(
      props.guid,
      props.point_of_sale,
      props.menu, props.sale_zone,
      props.link_tree,
      props.use_link_tree,
      props.number,
      props.email,
      props.qr_code);
  }

  serialize() {
    return {
      ...super.serialize(),
      point_of_sale: this.pointOfSale,
      menu: this.menu,
      sale_zone: this.saleZone,
      link_tree: this.linkTree,
      use_link_tree: this.useLinkTree,
      number: this.number,
      email: this.email
    };
  }
}
